(function () {
  const SELECTOR = '#assigned-rep';

  const ATTR_ID = 'Assigned Rep Id';
  const ATTR_NAME = 'Assigned Rep Name';

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function setCartAttributes(repId, repName) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          [ATTR_ID]: repId || '',
          [ATTR_NAME]: repName || '',
        },
      }),
    });
    return res.json();
  }

  function getSelectEl() {
    return document.querySelector(SELECTOR);
  }

  async function syncSelectFromCart() {
    const select = getSelectEl();
    if (!select) return;

    try {
      const cart = await getCart();
      const repId = cart?.attributes?.[ATTR_ID] || '';

      // set select to repId if option exists
      const hasOption = Array.from(select.options).some(o => o.value === repId);
      select.value = hasOption ? repId : '';

      // keep hidden name input in sync too
      const nameInput = document.getElementById('assigned-rep-name');
      if (nameInput) {
        const repName = cart?.attributes?.[ATTR_NAME] || '';
        nameInput.value = repName;
      }
    } catch (e) {
      console.error('[Assigned Rep] sync failed', e);
    }
  }

  // Event delegation (survives Empire AJAX cart rerenders)
  document.addEventListener('change', async (e) => {
    const target = e.target;
    if (!(target instanceof HTMLSelectElement)) return;
    if (!target.matches(SELECTOR)) return;

    const repId = target.value || '';
    const repName = target.selectedOptions?.[0]?.dataset?.repName || '';

    // update hidden input immediately
    const nameInput = document.getElementById('assigned-rep-name');
    if (nameInput) nameInput.value = repName;

    try {
      await setCartAttributes(repId, repName);
    } catch (err) {
      console.error('[Assigned Rep] update failed', err);
    }
  });

  // Initial sync
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSelectFromCart);
  } else {
    syncSelectFromCart();
  }

  // Empire cart refresh hook
  window.addEventListener('cartcount:update', syncSelectFromCart);
})();
